import React from "react"
import "./WeAre.css"


const WeAre = () => {
    return (
        <div className="we-are__section">
            <h1 className="we-are__title">من نحن؟</h1>
            <p className="we-are__paragraph">
                شركة التميز للاستشارات وأمن المعلومات هي شركة ليبية ذات مسؤولية محدودة ناشئة فتحت أبوابها سنة 2020 كنتاج لخبرة 20 سنة لمؤسسها أ.م صلاح الدين علي محمد الشتيوي العقيد المتقاعد من القوات البحرية الليبية في مجال الاتصالات وامن المعلومات.
                كانت الفكرة الاساسية وراء انشاء الشركة هو العمل على سد جزء من حاجة السوق الليبي في مجال أمن المعلومات بما في ذلك مساعدة الجهات العامة والخاصة للامتثال لمعايير أمن وحماية المعلومات الدولية وأي سياسات محلية أخرى ذات علاقة بأمن المعلومات من خلال خبراتها المحلية أومن خلال التعاون مع الشركات العربية والدولية المتميزة في المجال ولتمثل دور مكتب إدارة مشروعات محلي متواجد بأستمرار مع الزبون المحلي ومساعدته خطوة بخطوة نحو نيل شهادة الالتزام الدولية وبأقل التكاليف.
                المقر الرئيسي للشركة بمدينة طرابلس وتحمل من وزراة الاقتصاد والصناعة الليبية لمزوالة نشاط الاستشارات وامن المعلومات بترخيص رقم 01041961254 وتم قيدها بغرفة التجارة والصناعة والزراعة طرابلس.
            </p>
        </div>
    )
}

export default WeAre